// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1xA08","box":"WorkspacesBox_box__61c3F","node":"WorkspacesBox_node__2aqBg"};